import { useRef, useEffect, useState } from "react";
import ReactDOM from 'react-dom';

//import "../../public/";
const AutoComplete = (props) => {
  const autoCompleteRef = useRef();
  const inputRef = useRef();
  const [address, setAddress] = useState('');
  const [streetAddress, setStreetAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [county, setCounty] = useState('');
  const [country, setCountry] = useState('');
  const [defaultValue, setDefaultValue] = useState('');
  const autocomplete = useRef(null);
  const options = {
    fields: ["address_components", "geometry", "icon", "name"],
    types: [],
    ...props.autocompleteOptions
  };
  useEffect(() => {

    //@ts-ignore
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      options
    );
    initAutocomplete()

    // Google Places API overrides autocomplete attribute to "off" which Chrome ignores.
    // Use a MutationObserver to force it back to a value Chrome won't autofill.
    const input = inputRef.current as HTMLInputElement;
    if (input) {
      const observer = new MutationObserver(() => {
        if (input.getAttribute('autocomplete') !== 'do-not-autofill') {
          input.setAttribute('autocomplete', 'do-not-autofill');
        }
      });
      observer.observe(input, { attributes: true, attributeFilter: ['autocomplete'] });
      return () => observer.disconnect();
    }
  }, []);

  useEffect(() => {
    //This allows you to input a value prop to provide a default value for the field.
    if (props.value && !defaultValue) {
      setAddress(props.value)
      setDefaultValue(props.value)
    }

    if(props.value !== defaultValue){
      setAddress(props.value)
    }
  }, [props.value])

  const initAutocomplete = () => {
    const input = document.getElementById(props.id);
    //@ts-ignore
    autocomplete.current = new window.google.maps.places.Autocomplete(input, options);
    autocomplete.current.addListener('place_changed', handlePlaceSelect);
  };

  const handlePlaceSelect = () => {
    // console.log("HIT PLACES")
    const place = autocomplete.current.getPlace();
    if(!place || !place.address_components){
      console.log("No place selected or address components missing")
      return;
    }

    const addressComponents = place.address_components;
    let streetAddress = '';
    let city = '';
    let state = '';
    let postalCode = '';
    let country = '';
    let county = '';
    let subpremise = '';

    // process and use the address components as needed
    for (const component of addressComponents) {
      for(const componentType of component.types){

        switch (componentType) {
          case 'street_number':
            streetAddress = component.long_name;
            break;
          case 'route':
            // streetAddress += ' ' + component.long_name;
            streetAddress = streetAddress + ' ' + component.long_name;
            break;
          case 'subpremise': // Apartment, Suite, Building, Unit number
            subpremise = component.long_name;
            break;
          case 'locality':
            city = component.long_name;
            break;
          case 'administrative_area_level_1': // short_name for abbreviated state name
            state = component.short_name;
            break;
          case 'administrative_area_level_2': // Cleveland County should be Cleveland
            county = component.long_name;
            if(county.includes(' County')){
              county = county.replace(' County', '');
            }
            break;
          case 'postal_code':
            postalCode = component.long_name;
            break;
          case 'country':
            country = component.long_name;
            break;
          default:
            break;
        } // end componentType
      }
    }

    setStreetAddress(streetAddress);
    setCity(city);
    setState(state);
    setPostalCode(postalCode);
    setCounty(county)
    setCountry(country);
    setAddress(place.formatted_address);

    props.updateFormData(streetAddress, city, state, postalCode, county, country, subpremise)

    // Process and use the address components as needed
    //console.log(addressComponents);
  };

  const handleChange = (event) => {
    props.onChange(event.target.value)
    setAddress(event.target.value);
  };

  return (
    <input type="text" className="form-control" id={props.id} placeholder="123 Main Street..." ref={inputRef} value={address} onChange={(e) => { handleChange(e) }} autoComplete="do-not-autofill" name={`${props.id}_nocomplete`} />
  );
};
export default AutoComplete;
